export class LiveRequestTypeApi {
  constructor(projectId, util) {
    this.projectId = projectId;
    this.util = util;
  }
  async getRequestTypeCategories() {
    return this.util.jiraGet(`/rest/servicedesk/1/servicedesk/${this.projectId}/request-types`);
  }
}